<template>
  <v-flex class="openDepositAcc" data-qa="opendepositstepper-flex-hprjq">
    <Loader v-show="loaderEnabled"/>
    <v-layout
      v-if="!onSuccess"
      wrap
      class="ml-2 openDepositAcc--gradientBGposition"
     data-qa="opendepositstepper-layout-x3z27t">
      <v-flex
        xs12
        sm12
        md12
        lg12
        xl12
        :style="{ background: dashboardGradient, height: '180px' }"
       data-qa="opendepositstepper-flex-gay1tn">
        <v-container class="openDepositAcc--title-padding" data-qa="opendepositstepper-container-8c6j9p">
          <v-flex xs12 sm12 md12 lg12 xl12 data-qa="opendepositstepper-flex-awpos">
            <v-row v-if="isStepperEnabled" no-gutters data-qa="opendepositstepper-row-0caoc">
              <v-layout
                v-for="(step, index) in wizardConfig.steps"
                :key="index"
                row
                wrap
                class="hidden-md-and-down pb-2"
               :data-qa="`opendepositstepper-layout-31i0ct-${index}`">
                <v-flex xs2 sm2 md2 lg2 xl2 class="pt-8" :data-qa="`opendepositstepper-flex-3em7nv-${index}`">
                  <v-row justify="center" :data-qa="`opendepositstepper-row-9cb9n-${index}`">
                    <v-avatar :tile="false" size="22" color="white" :data-qa="`opendepositstepper-avatar-n1lm0q-${index}`">
                      <font
                        v-if="index < currentStep"
                        :color="primaryColor"
                        class="body-2 font-weight-bold"
                      >
                        <v-icon :color="primaryColor"
                          :data-qa="`opendepositstepper-icon-p2gsop-${index}`">mdi-check-circle-outline</v-icon
                        >
                      </font>
                      <font
                        v-else
                        :color="primaryColor"
                        class="body-2 font-weight-bold"
                        >{{ step.id }}</font
                      >
                    </v-avatar>
                  </v-row>
                </v-flex>
                <div xs7 sm7 md7 lg7 xl7 class="pt-6" :data-qa="`opendepositstepper-div-b137zm-${index}`">
                  <v-row no-gutters justify="start" :data-qa="`opendepositstepper-row-9osg68-${index}`">
                    <font class="body-2 font-weight-light white--text">
                      {{ $t(`termDepositActions.steps.${step.name}`) }}
                    </font>
                  </v-row>
                </div>
                <v-flex
                  v-if="index !== wizardConfig.steps.length - 1"
                  class="pt-8 pr-4 ml-10"
                  :data-qa="`opendepositstepper-flex-yeqxyk-${index}`">
                  <v-row no-gutters justify="center" :data-qa="`opendepositstepper-row-6pambk-${index}`">
                    <v-divider :data-qa="`opendepositstepper-divider-n9d3ce-${index}`"  color="white" />
                  </v-row>
                </v-flex>
              </v-layout>
              <v-layout class="hidden-lg-and-up openDepositAcc--gradientBGposition" data-qa="opendepositstepper-layout-z323k8">
                <RadialStepper
                  :config="{ steps: wizardConfig.steps, state: currentStep+1, displayWhiteText: true}"
                  class="hidden-lg-and-up white--text"
                />
              </v-layout>
            </v-row>
            <v-row v-else no-gutters class="pl-10 pt-4" data-qa="opendepositstepper-row-6v06cu">
              <font class="text-h5 white--text">{{ $t('termDepositActions.summary') }}</font>
            </v-row>
          </v-flex>
        </v-container>
      </v-flex>
    </v-layout>
    <v-flex
      v-if="!onSuccess"
      xs12
      sm12
      md12
      lg10
      xl10
      class="openDepositAcc--content-padding openDepositAcc--overlayCardFlex"
     data-qa="opendepositstepper-flex-d50prk">
      <v-layout row wrap class="openDepositAcc--content-padding" data-qa="opendepositstepper-layout-n2zwhe">
        <v-flex xs12 sm12 md12 lg12 xl12 data-qa="opendepositstepper-flex-r91rj">
          <v-card data-qa="opendepositstepper-card-nsd9s">
            <v-container data-qa="opendepositstepper-container-p1zw5b">
              <v-row
                v-show="isStepperEnabled"
                no-gutters
                justify="center"
                :class="{ 'ma-6': !$vuetify.breakpoint.smAndDown }"
               data-qa="opendepositstepper-row-649iy">
                <slot name="stepperContent" data-qa="opendepositstepper-slot-6xqa6"></slot>
              </v-row>
              <v-row v-show="!isStepperEnabled" no-gutters :class="{ 'ma-3': $vuetify.breakpoint.smAndDown, 'ma-6': !$vuetify.breakpoint.smAndDown }" data-qa="opendepositstepper-row-1nt0ya">
                <font class="font-weight-bold">
                  {{ userName }}, {{ $t('termDepositActions.summarySentence') }}
                  <font class="text-capitalize">{{ wizardConfig.accountLabel }} {{ $t('termDepositActions.confirmAccOpeningSentence') }}</font>
                </font>
                <v-flex lg12 data-qa="opendepositstepper-flex-ad295i">
                  <v-list v-if="reviewData && reviewData.length" data-qa="opendepositstepper-list-j1bz2t">
                    <v-list-item-content
                      v-for="(step, index) in reviewData"
                      :key="step.id"
                      class="py-1"
                     :data-qa="`opendepositstepper-list-item-content-ti3bp-${index}`">
                      <v-layout wrap class="pb-1" :data-qa="`opendepositstepper-layout-3tmgxg-${index}`">
                        <v-flex xs12 sm10 md10 lg10 xl10 :data-qa="`opendepositstepper-flex-1wx7gd-${index}`">
                          <span
                            class="body-2 overline font-weight-bold"
                            v-text="$t(`termDepositActions.steps.${step.name}`)"
                            :data-qa="`opendepositstepper-span-fqeeko-${index}`"></span>
                          <br :data-qa="`opendepositstepper-br-cywe5i-${index}`"  />
                          <span class="body-2 font-weight-light"
                            :data-qa="`opendepositstepper-span-4ffwsl-${index}`"><font color="#757575">{{ step.value }}</font></span
                          >
                        </v-flex>
                        <!-- <v-flex sm2 md2 lg2 xl2 data-qa="opendepositstepper-flex-cm8t4">
                          <v-btn
                            @click="editStepData('step', index)"
                            text
                            :color="primaryColor"
                             data-qa="opendepositstepper-btn-212bjc"><font class="font-weight-bold">EDIT</font></v-btn
                          >
                        </v-flex> -->
                      </v-layout>
                      <v-divider :data-qa="`opendepositstepper-divider-j5szp-${index}`"
                        v-if="index <= reviewData.length-2"
                      />
                    </v-list-item-content>
                    <v-flex v-if=" wizardConfig.formData.fundingAccountType === 'Internal'" data-qa="opendepositstepper-flex-d8q4y">
                      <v-list-item-content
                        v-for="(data, id) in wizardConfig.summaryAdditionalData"
                        :key="data.id"
                        class="py-1"
                       :data-qa="`opendepositstepper-list-item-content-zv6wxc-${id}`">
                      <v-divider :data-qa="`opendepositstepper-divider-ultrd-${id}`"  v-if=" id === 0" />
                        <v-layout wrap class="pb-1" :data-qa="`opendepositstepper-layout-5675ph-${id}`">
                          <v-flex xs12 sm10 md10 lg10 xl10 :data-qa="`opendepositstepper-flex-8vbsf4h-${id}`">
                            <span
                              class="body-2 overline font-weight-bold"
                              v-text="data.label"
                              :data-qa="`opendepositstepper-span-skxi1-${id}`"></span>
                            <br :data-qa="`opendepositstepper-br-zqvxhd-${id}`"  />
                            <span class="body-2 font-weight-light"
                              :data-qa="`opendepositstepper-span-ug0evb-${id}`"><font color="#757575">{{ data.value }}</font></span
                            >
                          </v-flex>
                          <!-- <v-flex xs12 sm2 md2 lg2 xl2 data-qa="opendepositstepper-flex-r9nwm">
                            <v-btn
                              @click="editStepData('additionalData', data.id)"
                              text
                              :color="primaryColor"
                               data-qa="opendepositstepper-btn-ce9fzp"><font class="font-weight-bold">EDIT</font></v-btn
                            >
                          </v-flex> -->
                        </v-layout>
                        <v-divider :data-qa="`opendepositstepper-divider-racqj-${id}`"
                          v-if="
                            !(
                              id ===
                              wizardConfig.summaryAdditionalData.length - 1
                            )
                          "
                        />
                      </v-list-item-content>
                    </v-flex>
                  </v-list>
                  <v-alert
                    v-if="wizardConfig.formData.isEndDateCommonForAllAccounts && (reviewData && reviewData.length)"
                    icon="mdi-information-outline"
                    class="v-alert--info"
                   data-qa="opendepositstepper-alert-oiupzd">
                    <font class="body-2 font-weight-regular">
                      {{ $t('termDepositActions.disclaimerForAccountsWithCommonEndDate') }}
                    </font>
                  </v-alert>
                </v-flex>
              </v-row>
              <v-card-actions class="pl-6" data-qa="opendepositstepper-card-actions-8cmeoi">
                <v-btn
                  @click="changeStep('decrement')"
                  :disabled="disableBackBtn()"
                  :color="primaryColor"
                  outlined
                  class="py-2 px-4"
                   data-qa="opendepositstepper-btn-ore8u">{{ $t('termDepositActions.backButton') }}</v-btn
                >
                <v-btn
                  @click="changeStep('increment')"
                  :disabled="disableNextBtn() || disableNextButton"
                  :color="primaryColor"
                  class="white--text py-2 px-4"
                   data-qa="opendepositstepper-btn-a4vfb">{{ nextBtnLabel }}</v-btn
                >
              </v-card-actions>
            </v-container>
          </v-card>
        </v-flex>
      </v-layout>
    </v-flex>

    <!-- Product Parameters -->
    <v-dialog v-model="onSuccess" width="800" :persistent="true" data-qa="opendepositstepper-dialog-hmf47e">
      <v-card class="pa-10" data-qa="opendepositstepper-card-bku79g">
        <v-flex class="px-6 py-2" data-qa="opendepositstepper-flex-17udfp">
          <v-row v-if="onSuccess" justify="center" data-qa="opendepositstepper-row-rmt1x">
            <v-flex xs12 sm12 md12 lg12 xl12 data-qa="opendepositstepper-flex-3vpeq">
              <v-row justify="center" data-qa="opendepositstepper-row-mk95tm">
                <inline-svg
                  :src="getTickIcon()"
                  width="100"
                  height="100"
                  aria-label="Tick Icon"
                ></inline-svg>
              </v-row>
              <!-- Account opened success msg -->
              <v-row class="text-center py-2" no-gutters data-qa="opendepositstepper-row-h7loyj">
                {{ `${$t("openDepositConfirm.successMsg.greet")}. ${$t("openDepositConfirm.successMsg.your")}
                ${ getAccLabel(wizardConfig.accountLabel) } ${$t("openDepositConfirm.successMsg.accOpened")}.`}}
              </v-row>
              <v-row no-gutters class="mt-4" data-qa="opendepositstepper-row-aw3qn">
                <DisplayDetails
                  :config="{
                    dataList: depositACConfirm.content,
                    translation: 'openDepositAcc',
                    screenType: 'confirmScreen',
                  }"
                />
              </v-row>
              <!-- Buttons -->
              <v-row justify="center" no-gutters class="py-2 mt-8" data-qa="opendepositstepper-row-a94dy">
                <v-btn
                  @click="routeTo('viewAcc')"
                  :color="primaryColor"
                  class="white--text text-none py-2 px-4"
                   data-qa="opendepositstepper-btn-pf31ga">{{ $t("openDepositAcc.viewAccDetailsBtnLabel") }}</v-btn
                >
              </v-row>
              <v-row justify="center" no-gutters class="py-2" data-qa="opendepositstepper-row-vv9pli">
                <v-btn @click="routeTo('home')" :color="primaryColor" text class="text-capitalize" data-qa="opendepositstepper-btn-mbw82">{{
                  $t("openSavingsAcc.btn.toHome")
                }}</v-btn>
              </v-row>
            </v-flex>
          </v-row>
        </v-flex>
      </v-card>
    </v-dialog>
  </v-flex>
</template>

<script>
import '@/styles/pages/accounts/deposits/openDepositAccount.scss'
import event from '@/util/event'
import store from '@/core/store'
import DisplayDetails from '@/views/common/DisplayDetails.vue'
import preload from '@/util/preload'
import _ from 'lodash'
import Loader from '../../../components/common/Loader.vue'

export default {
  name: 'open-deposit-acc',
  props: {
    wizardConfig: Object
  },
  components: {
    Loader,
    DisplayDetails,
    RadialStepper: () => import('@/components/RadialStepper.vue')
  },
  data () {
    return {
      loaderEnabled: false,
      disableNextButton: false,
      isAccountCreated: false,
      currentStep: 0,
      enableNextBtn: false,
      isStepperEnabled: true,
      userName: '',
      nextBtnLabel: this.$t('termDepositActions.nextButton'),
      onSuccess: false,
      accDetails: {},
      depositACConfirm: {},
      reviewData: [],
      enableNextStepMI: ['CAPITALISE', 'CAPTALISE', 'NO-INSTRUCTION', 'NOINSTRUCTION', 'MANUALREDEMPTION', 'NOT-APPLICABLE', 'NOTAPPLICABLE']
    }
  },
  created () {
    const data = store.getters['profileStore/profileData'].customerDetails
    this.userName = data.fullName || 'Roger Moore'
    event.$on('enableNextBtn', (arg) => {
      this.enableNextBtn = true
    })
    event.$on('disableOpenDesositNextBtn', (args) => {
      this.disableNextButton = args
    })
    event.$on('onTermDepositACCreation', (arg) => {
      this.loaderEnabled = true
      this.isAccountCreated = true
      this.accDetails = arg
      this.depositACConfirm = {
        content: [
          {
            label: 'accountNumber',
            value: this.accDetails.accountDetails.accountId
          },
          {
            label: 'status',
            value: this.accDetails.accountDetails.accountStatus
          },
          {
            label: 'sortCode',
            value: this.accDetails.accountDetails.sortCode
          },
          {
            label: 'term',
            value: this.accDetails.accountDetails.tenor
          },
          {
            label: 'interestRate',
            value: this.accDetails.accountDetails.interestRate
          },
          {
            label: 'depositAmount',
            value: this.accDetails.accountDetails.principalAmount
          },
          {
            label: 'maturityAmount',
            value: this.accDetails.maturityDetails.maturityAmount
          },
          {
            label: 'maturityDate',
            value: this.accDetails.maturityDetails.maturityDate
          },
          {
            label: 'maturityInstrunctions',
            // subLabel: 'Where do you want to keep your money at the end of Deposit Term',
            value: this.accDetails.maturityDetails.onMaturity
          },
          {
            label: this.accDetails.accountDetails.isFundingAccOwn ? 'fundingNominatedAccount' : 'fundAccountNumber',
            value: this.accDetails.accountDetails.fundingAccount
          },
          {
            label: this.accDetails.accountDetails.isPayAwayAccOwn ? 'maturityNominatedAccount' : 'maturityAccount',
            value: ['NO-INSTRUCTION', 'CAPITALISE', 'NOT-APPLICABLE'].includes(this.wizardConfig.formData.selectedMaturityOption) ? 'N/A' : this.accDetails.maturityDetails.payAwayAccount
          }
        ]
      }

      if (this.wizardConfig.offerInfo.interestPayoutMethod === 'PIP') {
        this.depositACConfirm.content.push({
          label: this.wizardConfig.formData.isInterestPayAwayAccOwn ? 'payInterestToAccountNominated' : 'payInterestToAccount',
          value: this.wizardConfig.formData.selectedInterestPayAwayAcc
        })
      }
      if (this.accDetails?.accountDetails?.accountOwnership === 'JOINT') {
        const { jointCustomerDetails, modeOfOperation } = this.accDetails.accountDetails
        this.depositACConfirm.content.splice(6, 0, {
          label: 'jointAccount',
          value: this.$t('common.yes')
        }, {
          label: 'jointAccountOwner',
          value: jointCustomerDetails
        }, {
          label: 'modeOfOperation',
          value: this.$t(`systemEnums.modeOfOperations.${modeOfOperation}`)
        })
      }
      // TODO this.wizardConfig.formData.fundingAccountType === 'External' && this.depositACConfirm.content.splice(4, 1) // fix DOB-1071
      setTimeout(() => {
        this.onSuccess = true
        event.$emit('openDepositAccComplete', true)
      }, 300)
    })
    this.loaderEnabled = false
  },
  methods: {
    disableNextBtn () {
      const formData = this.wizardConfig.formData
      const self = this
      if (this.currentStep === this.wizardConfig.steps.length) {
        const value = !this.enableNextBtn
        return value
      }
      switch (self.currentStep) {
        case 0:
          if (formData.fundingAccountType === 'Internal') {
            self.disableNextButton = !formData.selectedInternalFundingAccount
          } else if (formData.fundingAccountType === 'External') {
            self.disableNextButton = !formData.selectedExternalFundingAccount
          } else self.disableNextButton = true
          break
        case 1:
          if (formData.fundingAccountType === 'Internal') {
            self.disableNextButton = !formData.depositAmount || !formData.term || this.wizardConfig.depositAmtError || this.wizardConfig.termError
          } else if (formData.fundingAccountType === 'External') {
            self.disableNextButton = !formData.term || this.wizardConfig.termError
          } else self.disableNextButton = true
          break
        case 2:
          if (formData.selectedMaturityOption) {
            if (self.enableNextStepMI.includes(formData.selectedMaturityOption)) {
              if (this.wizardConfig.offerInfo.interestPayoutMethod === 'PIP') {
                self.disableNextButton = Boolean(!formData.selectedInterestPayAwayAcc)
              } else self.disableNextButton = false
            } else {
              if ((formData.payAwayAccountType === 'Internal' && !formData.selectedInternalPayAwayAccount) ||
          (formData.payAwayAccountType === 'External' && !formData.selectedExternalPayAwayAccount)) {
                self.disableNextButton = true
              } else {
                if (this.wizardConfig.offerInfo.interestPayoutMethod === 'PIP') {
                  self.disableNextButton = Boolean(!formData.selectedInterestPayAwayAcc)
                } else self.disableNextButton = false
              }
              // TODO if ((formData.fundingAccountType === 'Internal' && !formData.selectedInternalPayAwayAccount) ||
              // (formData.fundingAccountType === 'External' && !formData.selectedExternalPayAwayAccount)) {
              //       self.disableNextButton = true
              //     } else {
              //       self.disableNextButton = false
              //     }
            }
          } else {
            self.disableNextButton = true
          }
          /* DOB-642 changes self.disableNextButton = !'formData.selectedMaturityOption */
          break
        case 3:
          if (formData.payAwayAccountType === 'Internal') {
            self.disableNextButton = !formData.selectedInternalPayAwayAccount
          } else if (formData.payAwayAccountType === 'External') {
            self.disableNextButton = !formData.selectedExternalPayAwayAccount
          } else if (['NO-INSTRUCTION', 'CAPITALISE', 'NOT-APPLICABLE'].includes(formData.selectedMaturityOption)) {
            self.disableNextButton = false
          } else self.disableNextButton = true
          break
        default:
          break
      }
    },
    disableBackBtn () {
      if (this.currentStep === 0) {
        return true
      } else return false
    },
    async routeTo (to) {
      const actionList = await preload.getTDActionList(_.upperCase(this.accDetails.accountDetails.accountStatus), this.accDetails.accountDetails.startDate)
      const currentBalance = this.accDetails.currentBalance
      const maturityAmount = this.accDetails.maturityAmount
      switch (to) {
        case 'home':
          setTimeout(() => {
            this.$router.push({ path: '/home' })
          }, 600)
          break
        case 'viewAcc':
          this.$router.push({
            name: 'AccountDetails',
            params: {
              productName: this.wizardConfig.accountLabel,
              product: {
                ...this.accDetails.accountDetails,
                ...this.accDetails.maturityDetails,
                actionList,
                currentBalance,
                maturityAmount
              },
              balance: this.accDetails.accountDetails.principalAmount,
              accountId: this.accDetails.accountDetails.accountId,
              accountName: this.accDetails.accountDetails.customerName,
              accountType: 'TD'
            }
          })
          break
        default:
          break
      }
    },
    getTickIcon () {
      return this.getSvgIconSrc('Tick')
    },
    async changeStep (action) {
      if (action === 'increment') {
        this.currentStep++
        if (this.currentStep === this.wizardConfig.steps.length) {
          if (this.wizardConfig.formData.isEndDateCommonForAllAccounts && this.wizardConfig?.offerInfo?.interestPayoutMethod !== 'PIP' && this.wizardConfig.formData.fundingAccountType !== 'External') {
            await this.wizardConfig.getTermDepositMaturity()
            this.enableNextBtn = true
          }
          // onClick of next btn in last step
          this.setReviewScreenData()
          this.isStepperEnabled = false
          this.nextBtnLabel = this.$t('termDepositActions.confirmButton')
        } else if ((this.currentStep >= this.wizardConfig.steps.length + 1) && !this.isAccountCreated) {
          // onClick of confirm btn in summary page
          event.$emit('createTermDepositAC', true)
        } else {
          event.$emit('onNextStep', this.currentStep + 1)
        }
      } else {
        if (!(this.currentStep === 0)) {
          if (!this.isStepperEnabled) {
            this.nextBtnLabel = this.$t('termDepositActions.nextButton')
            this.isStepperEnabled = true
            this.currentStep = this.wizardConfig.steps.length
            this.currentStep--
            event.$emit('onPreviousStep', this.currentStep + 1)
          } else {
            this.currentStep--
            event.$emit('onPreviousStep', this.currentStep + 1)
          }
        }
      }
    },
    editStepData (toBeEdited, index) {
      this.nextBtnLabel = this.$t('termDepositActions.nextButton')
      this.isStepperEnabled = true
      this.currentStep = index
      event.$emit('onNextStep', this.currentStep + 1)
      if (this.currentStep === 0 || this.currentStep === 3) {
        // TODO event.$emit('editStepsData', { edit: true, formData: this.wizardConfig.formData, currentStep: this.currentStep })
        // store.dispatch('userStore/setUserData', { openDepositAccDeatils: { formData : this.wizardConfig.formData, currentStep: this.currentStep }})
      }
    },
    setReviewScreenData () {
      this.reviewData = [
        {
          name: this.wizardConfig.formData.isFundingAccOwn ? 'fundingNominatedAccount' : this.wizardConfig.steps[0].name,
          value: this.wizardConfig.formData.fundingAccountType === 'Internal' ? this.wizardConfig.formData.selectedInternalFundingAccount : `${this.wizardConfig.formData.selectedExternalFundingAccount} - ${this.wizardConfig.formData.fundingSortCode}`
        },
        {
          name: this.wizardConfig.steps[1].name,
          value: this.$t('termDepositActions.depositDetails', {
            depositAmount: this.$formatter.currency.customFormatter(this.wizardConfig.formData.depositAmount, this.wizardConfig.currencyFormat),
            term: this.wizardConfig.formData.selectedTerm,
            interestRate: this.wizardConfig.formData.interestRate
          })
        },
        {
          name: 'maturityInstruction',
          value: this.$t(`systemEnums.maturityInstructions.${this.wizardConfig.formData.selectedMaturityOption}`)
        }
        // {
        //   name: this.wizardConfig.formData.isPayAwayAccOwn ? 'maturityNominatedAccount' : 'maturityAccount',
        //   value: this.wizardConfig.formData.payAwayAccountType === 'Internal' ? this.wizardConfig.formData.selectedInternalPayAwayAccount : `${this.wizardConfig.formData.selectedExternalPayAwayAccount} -
        //     ${this.wizardConfig.formData.payawaySortCode}`
        // }
      ]

      if (!['NO-INSTRUCTION', 'CAPITALISE', 'NOT-APPLICABLE'].includes(this.wizardConfig.formData.selectedMaturityOption)) {
        this.reviewData.push({
          name: this.wizardConfig.formData.isPayAwayAccOwn ? 'maturityNominatedAccount' : 'maturityAccount',
          value: this.wizardConfig.payAwayAccount
        })
      }

      if (this.wizardConfig.offerInfo.interestPayoutMethod === 'PIP') {
        this.reviewData.push({
          name: this.wizardConfig.formData.isInterestPayAwayAccOwn ? 'payInterestToAccountNominated' : 'payInterestToAccount',
          value: this.wizardConfig.formData.selectedInterestPayAwayAcc
        })
      }
      // DOB-642 changes this.wizardConfig.steps[1].value = `${this.$formatter.currency.format(this.wizardConfig.formData.depositAmount)} for ${this.wizardConfig.formData.term} ${this.getSelectedTermOption()} at ${this.wizardConfig.formData.interestRate} Interest Rate`
      // // this.wizardConfig.steps[2].value = this.$t(`systemEnums.maturityInstructions.${this.wizardConfig.formData.selectedMaturityOption}`)
      // this.wizardConfig.steps[2].value = {
      //   maturityInstructions: this.$t(`systemEnums.maturityInstructions.${this.wizardConfig.formData.selectedMaturityOption}`),
      //   payAwayAccount: this.wizardConfig.formData.payAwayAccountType === 'Internal' ? this.wizardConfig.formData.selectedInternalPayAwayAccount : `${this.wizardConfig.formData.selectedExternalPayAwayAccount} - ${this.wizardConfig.formData.payawaySortCode}`
      // }
      // this.wizardConfig.steps[3].value = this.wizardConfig.formData.payAwayAccountType === 'Internal' ? this.wizardConfig.formData.selectedInternalPayAwayAccount : `${this.wizardConfig.formData.selectedExternalPayAwayAccount} - ${this.wizardConfig.formData.payawaySortCode}`
      if (this.wizardConfig?.offerInfo?.accountOperationTypeDetails?.selectedAccountOperationType === 'JOINT') {
        const { selectedJointAccountHolder: { jointCustomerName, jointCustomerId }, selectedModeOfOperation } = this.wizardConfig.offerInfo.accountOperationTypeDetails
        const itemsToAdd = [{
          name: 'jointAccount',
          value: this.$t('common.yes')
        }, {
          name: 'jointAccountOwner',
          value: `${jointCustomerName} - ${jointCustomerId}`
        }, {
          name: 'modeOfOperation',
          value: this.$t(`systemEnums.modeOfOperations.${selectedModeOfOperation}`)
        }]
        this.reviewData.splice(2, 0, ...itemsToAdd)
      }
      this.wizardConfig.summaryAdditionalData[0].value = this.$formatter.currency.customFormatter(this.wizardConfig.formData.maturityAmount, this.wizardConfig.currencyFormat)
      this.wizardConfig.summaryAdditionalData[1].value = this.$formatter.formatDate(this.wizardConfig.formData.maturityDate)
    },
    // DOB-642 changes setReviewScreenData () {
    //   this.wizardConfig.steps[0].value = this.wizardConfig.formData.fundingAccountType === 'Internal' ? this.wizardConfig.formData.selectedInternalFundingAccount : `${this.wizardConfig.formData.selectedExternalFundingAccount} - ${this.wizardConfig.formData.fundingSortCode}`
    //   this.wizardConfig.steps[1].value = `${this.$formatter.currency.format(this.wizardConfig.formData.depositAmount)} for ${this.wizardConfig.formData.term} ${this.getSelectedTermOption()} at ${this.wizardConfig.formData.interestRate} Interest Rate`
    //   // this.wizardConfig.steps[2].value = this.$t(`systemEnums.maturityInstructions.${this.wizardConfig.formData.selectedMaturityOption}`)
    //   this.wizardConfig.steps[2].value = {
    //     maturityInstructions: this.$t(`systemEnums.maturityInstructions.${this.wizardConfig.formData.selectedMaturityOption}`),
    //     payAwayAccount: this.wizardConfig.formData.payAwayAccountType === 'Internal' ? this.wizardConfig.formData.selectedInternalPayAwayAccount : `${this.wizardConfig.formData.selectedExternalPayAwayAccount} - ${this.wizardConfig.formData.payawaySortCode}`
    //   }
    //   // this.wizardConfig.steps[3].value = this.wizardConfig.formData.payAwayAccountType === 'Internal' ? this.wizardConfig.formData.selectedInternalPayAwayAccount : `${this.wizardConfig.formData.selectedExternalPayAwayAccount} - ${this.wizardConfig.formData.payawaySortCode}`
    //   this.wizardConfig.summaryAdditionalData[0].value = this.$formatter.currency.format(this.wizardConfig.formData.maturityAmount)
    //   this.wizardConfig.summaryAdditionalData[1].value = this.$formatter.formatDate(this.wizardConfig.formData.maturityDate)
    // },
    getSelectedTermOption () {
      const termOption = parseInt(this.wizardConfig.formData.term) > 1 ? this.wizardConfig.formData.selectedTermOption : this.wizardConfig.formData.selectedTermOption.slice(0, -1)
      return termOption
    },
    getAccLabel (accLabel) {
      return _.upperCase(accLabel)
    }
  }
}
</script>
